<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-card :elevation="1">
        <v-card-item>
          <v-card-title class="text-left">expense txns</v-card-title>
          <template v-slot:append>

          </template>  
        </v-card-item>
        <v-divider></v-divider>

        <v-container>
          <v-row >
            <v-col cols="12" sm="4">
              <v-sheet class="ma-2 pa-2">
                <v-select
                  density="comfortable"
                  hide-details
                  class="mb-3"
                  width="max"
                  label=""
                  v-model="selected_expense"
                  :items="this.expenses"
                  item-title="identifier"
                  item-value="id"
                  @update:modelValue="updateSelectedExpenseCategory()"
                  ></v-select>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="heading-text">months</div>
              <div class="d-flex align-center flex-column pa-6">
                <v-btn-toggle
                  v-model="months"
                  mandatory
                  @update:modelValue="updateSelectedMonths()"
                >
                  <v-btn value="1">1</v-btn>
                  <v-btn value="3">3</v-btn>
                  <v-btn value="12">12</v-btn>
                  <v-btn value="all">all</v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="heading-text">total</div>
                <v-sheet class="ma-2 pa-2">
                  <Transition name="fade-in" mode="out-in">
                    <span :key="monthsKey">{{ Number(this.expense_sum.sum).toLocaleString() }}</span>
                  </Transition>
                </v-sheet>
            </v-col>
          </v-row>
        </v-container>

        <v-divider></v-divider>
          <v-card-text v-if="monthly_totals !== null">
            <div style="width: 50%; margin: 0 auto">
              <BarChart :chartData="barChartData" :chartOptions="barChartOptions" />
            </div>
          </v-card-text>

        <v-divider></v-divider>
          <v-card-text>
            <Transition name="fade-in" mode="out-in">
              <v-container :key="monthsKey" class="table-scroll">
                <table>
                  <tr>
                    <th class="">date</th>
                    <th class="">description</th>
                    <th class="">merchant</th>
                    <th class="">amount</th>
                  </tr>
                  <tr v-for="txn in bank_txns" :key="txn.id">
                    <td class="txn_text">{{ showDateFormat(txn.txn_date) }}</td>
                    <td class="txn_text">{{ txn.txn_description }}</td>
                    <td class="txn_text">{{ txn.bank_merchant_name }}</td>
                    <td class="txn_text">{{ txn.amount }}</td>
                  </tr>
                </table>
              </v-container>
            </Transition>
          </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  

  <!-- modals -->

</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import moment from 'moment';
import BarChart from './charts/BarChart.vue';

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      expenses: [],
      selected_expense: 0,
      months: "1",
      expense_sum: "",
      bank_txns: [],
      bank_txns_page: 1,
      initialized: false,
      monthly_totals: [],
      monthsKey: 0,
    };
  },
  async created() {
    await this.getExpenses();
    this.setInitialExpenseSearchCriteria();
    this.initialized = true;
    this.getBankTxns();
    this.getExpenseSum();
    this.getMonthlyTotals();
  },
  beforeRouteUpdate(to) {
    const newId = to.params.id;
    if (newId && this.initialized && this.expenses.length) {
      this.selected_expense = Number(newId);
      const expense = this.expenses.find(x => x.id === Number(newId));
      this.months = this.getValidMonths(expense ? expense.minimum_months_reporting : 1);
      this.getBankTxns();
      this.getExpenseSum();
      this.getMonthlyTotals();
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    barChartData() {
      const endOfLastMonth = moment().subtract(1, 'months').endOf('month');
      const monthsRange = [];
      for (let i = 11; i >= 0; i--) {
        monthsRange.push(endOfLastMonth.clone().subtract(i, 'months').format('YYYY-MM'));
      }
      const totalsByMonth = {};
      this.monthly_totals.forEach(row => { totalsByMonth[row.month_year] = row.total; });
      const highlightStart = this.months === "all" ? 0 : 12 - Number(this.months);
      return {
        labels: monthsRange.map(m => moment(m, 'YYYY-MM').format('MMM YY')),
        datasets: [{
          data: monthsRange.map(m => totalsByMonth[m] != null ? -totalsByMonth[m] : 0),
          backgroundColor: monthsRange.map((m, i) => i >= highlightStart ? '#1976D2' : '#CFD8DC'),
          borderRadius: 4,
        }]
      };
    },
    barChartOptions() {
      return {
        responsive: true,
        aspectRatio: 4,
        animation: { duration: 150, easing: 'easeInQuart' },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: ctx => '$' + Number(ctx.parsed.y).toLocaleString()
            }
          },
          datalabels: {
            color: ctx => ctx.dataset.backgroundColor[ctx.dataIndex] === '#1976D2' ? '#ffffff' : '#333333',
            formatter: value => Math.round(value).toLocaleString()
          }
        },
        scales: {
          y: {
            ticks: {
              callback: value => '$' + Number(value).toLocaleString()
            }
          }
        }
      };
    }
  },
  mounted() {
    this.enableScrollEventListener();
  },
  unmounted() {
    this.disableScrollEventListener();

  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async getBankTxns(){
      try {
      const response  = await axios.get("/bank/txns/expensecategory/"+this.selected_expense,
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        },
        params: {
          // page: this.bank_txns_page
          months: this.months
        }
      });
        this.bank_txns = response.data;
        // this.bank_txns_page++; // increment the page count



        /*
        response.data.forEach(txn => {
          
          this.bank_txns.push(txn);

          // setup state on expense catagory
          if(txn.expense_category_id){ // if an expense category has been set on a bank txn
            this.selected_expense[txn.id] = txn.expense_category_id; // set it in the v-model for that expense category data
            this.bank_txn_expense_category_state[txn.id] = "persisted"; // set the state of expense category data
          } 
          else if(txn.suggested_expense_category_id){ // if a suggested expense category has been identified on a bank txn
            this.selected_expense[txn.id] = txn.suggested_expense_category_id; // set it in the v-model for that txn expense dropdown
            this.bank_txn_expense_category_state[txn.id] = "suggested";
          }
          else{ // the txn does not have an expense category set and does not have a suggested expense category
            this.bank_txn_expense_category_state[txn.id] = "awaiting";
          }
        */

      } catch (error) {
        this.showSnackbar({ message: 'Failed to load bank transactions' });
      }
    },  
    async getExpenses(){
      try {
      const response  = await axios.get("/expenses/categories/",
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.expenses = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load expense categories' });
      }
    },
    async getExpenseSum(){
      try {
      const response  = await axios.get("/expenses/categories/" + this.selected_expense + "/sum?months=" + this.months,
      {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
          this.expense_sum = response.data;
  
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load expense summary' });
      }
    },
    async getMonthlyTotals(){
      try {
        const response = await axios.get("/expenses/categories/" + this.selected_expense + "/monthly", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.monthly_totals = response.data;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load monthly totals' });
      }
    },
    async updateSelectedExpenseCategory(){
      if (!this.initialized) return;
      this.months = this.getValidMonths(this.expenses.find(x => x.id === Number(this.selected_expense))?.minimum_months_reporting);
      this.getExpenseSum();
      this.getBankTxns();
      this.getMonthlyTotals();
    },
    async updateSelectedMonths(){
      if (!this.initialized) return;
      this.monthsKey++;
      this.getExpenseSum();
      this.getBankTxns();
    },
    getValidMonths(value){
      const valid = ["1", "3", "12", "all"];
      const str = String(value);
      return valid.includes(str) ? str : "1";
    },
    setInitialExpenseSearchCriteria(){
      if(this.$route.params.id){
        this.selected_expense = Number(this.$route.params.id);
        const expense = this.expenses.find(x => x.id === Number(this.$route.params.id));
        const queryMonths = this.$route.query.months;
        this.months = queryMonths
          ? this.getValidMonths(queryMonths)
          : this.getValidMonths(expense ? expense.minimum_months_reporting : 1);
      }
      else{
        this.selected_expense = this.expenses[0].id;
        this.months = this.getValidMonths(this.expenses[0].minimum_months_reporting);
      }
    },
    showDateFormat(rawDate){
      return moment(rawDate).format('DD/MM/YY');
    },
    enableScrollEventListener(){
      // best practce is to add a debounce functon here so this doesnt get too noisy and effect performance.
      window.addEventListener("scroll", this.getNextTxns);
    },
    getNextTxns(){
      if (!this.initialized) return;
      let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight;
      if (bottomOfWindow) {
        this.getBankTxns();
      }

    },
    disableScrollEventListener() {
      window.removeEventListener("scroll", this.getNextTxns);
    },
  }
};
</script>


<style scoped>
table{
  width: 100%;
}

table tr{
  cursor: pointer;
}

.fade-in-enter-active {
  transition: opacity 150ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-in-leave-active {
  transition: opacity 112ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-in-enter-from,
.fade-in-leave-to {
  opacity: 0;
}

.green_text{
  color: green;
}

.red_text{
  color: red;
}

.txn_text{
  font-weight: 300;
  font-size: 1.1rem;
}
.heading-text{
  font-size: 2rem;
}


</style>